import _get from 'lodash/get'

// Knack sends '' for a blank status, clearLaborerSMSStatus writes null, and
// lodash get only defaults undefined. Read through this so null never
// reaches .length.
export default function smsStatusOf(assgnt) {
  return _get(assgnt, 'ASSIGNMENT_SMS_STATUS') || ''
}
